import React from 'react';
import {
  ButtonContainer,
  CompanyCardWrapper,
  CompanyLogo,
  CompanyNameContainer,
  RedCircle,
  WhiteCross,
  CompanyLogoWrapper,
  LabelAndCheckboxContainer,
} from './styles';
import { CheckboxMark } from 'components/Checkbox/Checkbox';

export const CompanyCard = ({ name, logo, testsOnly, deleteFunction, testsOnlyFunction }) => {
  return (
    <CompanyCardWrapper>
      <ButtonContainer>
        <LabelAndCheckboxContainer>
          <CheckboxMark checked={testsOnly} onChange={testsOnlyFunction} />
        </LabelAndCheckboxContainer>

        <RedCircle onClick={deleteFunction}>
          <WhiteCross />
        </RedCircle>
      </ButtonContainer>
      <CompanyLogoWrapper>
        <CompanyLogo src={logo}></CompanyLogo>
      </CompanyLogoWrapper>
      <CompanyNameContainer>{name}</CompanyNameContainer>
    </CompanyCardWrapper>
  );
};
